<script setup>
import { reactiveOmit } from '@vueuse/core';
import { DatePickerGridRow, useForwardProps } from 'reka-ui';
import { cn } from '@/lib/utils';

const props = defineProps({
    asChild: { type: Boolean, required: false },
    as: { type: null, required: false },
    class: { type: null, required: false },
});

const delegatedProps = reactiveOmit(props, 'class');

const forwardedProps = useForwardProps(delegatedProps);
</script>

<template>
    <DatePickerGridRow :class="cn('flex', props.class)" v-bind="forwardedProps">
        <slot />
    </DatePickerGridRow>
</template>
